import { router } from '@/router'
import TmzService from '@/service/tmz.service'
import ReportService from '@/service/report.service'
import axios from 'axios'

export default {
	state: {
		tmzReports: [],
		tmzReportsCount: 0,
		otherTmzReports: [],
		otherTmzReportsCount: 0,
		tmzReport: {},
		liquidDemandReport: {},
		liquidDemandReportRequest: [],
		liquidUnclaimedReport: {},
		liquidUnclaimedReportRequest: [],
		illiquidReport: {},
		illiquidReportRequest: [],
		categoryFilters: [],
		tmcCodesFilters: [],
		tmcNamingsFilters: [],
		isFirstTmz: false,
		progress: 0,
		tmzSearchResults: [],
		tmzSearchPageCount: 0,
	},
	getters: {
		tmzReports(state) {
			return state.tmzReports
		},
		tmzReportsCount(state) {
			return state.tmzReportsCount
		},
		otherTmzReports(state) {
			return state.otherTmzReports
		},
		tmzOtherReportsCount (state) {
			return state.otherTmzReportsCount
		},
		TMZREPORT(state) {
			return state.tmzReport
		},
		tmzReport(state) {
			return state.tmzReport
		},
		liquidDemandReportRequest(state) {
			return state.liquidDemandReportRequest
		},
		liquidDemandReport(state) {
			return state.liquidDemandReport
		},
		liquidUnclaimedReport(state) {
			return state.liquidUnclaimedReport
		},
		liquidUnclaimedReportRequest(state) {
			return state.liquidUnclaimedReportRequest
		},
		illiquidReport(state) {
			return state.illiquidReport
		},
		illiquidReportRequest(state) {
			return state.illiquidReportRequest
		},
		categoryFilters(state) {
			return state.categoryFilters
		},
		tmcCodesFilters(state) {
			return state.tmcCodesFilters
		},
		tmcNamingsFilters(state) {
			return state.tmcNamingsFilters
		},
		isFirstTmz(state) {
			return state.isFirstTmz
		},
		uploadProgress(state) {
			return state.progress
		},
	},
	mutations: {
		setTmzSearchResults(state, payload) {
			state.tmzSearchResults = payload
		},
		setTmzSearchPageCount(state, payload) {
			state.tmzSearchPageCount = payload
		},
		setTmzOtherReports(state, payload) {
			state.otherTmzReports = payload
		},
		setTmzOtherReportsCount (state, payload) {
			state.otherTmzReportsCount = payload
		},
		setTmzReports(state, payload) {
			state.tmzReports = payload
		},
		setTmzReportsCount(state, payload) {
			state.tmzReportsCount = payload
		},
		setTmzReport(state, tmz_report) {
			state.tmzReport = tmz_report
		},
		setLiquidDemandReportRequest(state, payload) {
			state.liquidDemandReportRequest = payload
		},
		setLiquidDemandReport(state, payload) {
			state.liquidDemandReport = payload
		},
		setLiquidUnclaimedReportRequest(state, payload) {
			state.liquidUnclaimedReportRequest = payload
		},
		setLiquidUnclaimedReport(state, payload) {
			state.liquidUnclaimedReport = payload
		},
		setIlliquidReportRequest(state, payload) {
			state.illiquidReportRequest = payload
		},
		setIlliquidReport(state, payload) {
			state.illiquidReport = payload
		},
		setCategoryFiltersData(state, payload) {
			state.categoryFilters = payload
		},
		setTmcCodesFiltersData(state, payload) {
			state.tmcCodesFilters = payload
		},
		setTmcNamingsFiltersData(state, payload) {
			state.tmcNamingsFilters = payload
		},
		setIsFirstTmz(state, isFirst) {
			state.isFirstTmz = isFirst
		},
		setProgress(state, payload) {
			state.progress = payload
		},
	},
	actions: {
		downloadTemplate(step) {
			let payload = {
				type: step
			}

			axios.get('/tmz/template-tmz/', {
				params: payload
			}).then((response) => {
				const url = response.data[0].file_data
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', response.data[0].file_name)
				document.body.appendChild(link)
				link.click()
			})
		},
		updateProgress(ctx, payload) {
			ctx.commit('setProgress', payload)
		},
		searchTmz({ commit }, payload) {
			// http://167.99.251.251/api/tmz/search_tmz/
			console.log(payload)
			return axios.post('tmz/search_tmz/', payload).then(response => {
				console.log(response.data)
				commit('setTmzSearchResults', response.data.results)
				commit('setTmzSearchPageCount', response.data.num_pages)
				return response.data
			})
		},
		searchTmzKmg({ commit }, payload) {
			return axios.post('tmz/search_tmz_for_kmg/', payload).then(response => {
				commit('setTmzSearchResults', response.data.results)
				commit('setTmzSearchPageCount', response.data.num_pages)
				return response.data
			})
		},
		getFiltersData(context, payload) {
			return new Promise((resolve, reject) => {
				axios
					.get('tmz/tmz-report-filter/', {
						params: {
							reportId: payload.reportId,
							typeReport: payload.typeReport,
						},
					})
					.then(response => {
						const data = response.data
						let categoryArray = []
						let tmcCodes = []
						let namingsArray = []

						for (let i = 0; i < Object.keys(data.category_arr).length; i++) {
							categoryArray.push({
								value: i,
								text: response.data.category_arr[i],
							})
						}

						for (let i = 0; i < Object.keys(data.code_tmc_arr).length; i++) {
							tmcCodes.push({
								value: i,
								text: response.data.code_tmc_arr[i],
							})
						}

						for (let i = 0; i < Object.keys(data.name_tmc_arr).length; i++) {
							namingsArray.push({
								value: i,
								text: response.data.name_tmc_arr[i],
							})
						}
						context.commit('setCategoryFiltersData', categoryArray)
						context.commit('setTmcCodesFiltersData', tmcCodes)
						context.commit('setTmcNamingsFiltersData', namingsArray)
						resolve(response)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		checkTmzStep({ commit, dispatch }) {
			return TmzService.checkTmzStep()
				.then(response => {
					let step = response.data.step
					let tmzId = response.data.tmz_id
					let is_first_tmz = response.data.is_first
					let status = response.data.status
					commit('setIsFirstTmz', is_first_tmz)
					if (step === 1) {
						router.push({
							name: 'view-tmz-step-first',
							params: { id: tmzId },
						})
					} else if (step === 0 && status === 'Ошибка') {
						router.push({
							name: 'view-tmz-step-first',
							params: { id: tmzId },
						})
					} else if (step === 2) {
						router.push({
							name: 'view-tmz-step-first',
							params: { tmzId: tmzId },
						})
					} else if (step === 3) {
						router.push({
							name: 'view-tmz-step-second',
							params: { id: tmzId },
						})
					} else if (step === 4) {
						router.push({
							name: 'view-tmz-step-third',
							params: { tmzId: tmzId },
						})
					} else if (step === 5) {
						router.push({
							name: 'view-tmz-step-third',
							params: { id: tmzId },
						})
					} else {
						router.push({ name: 'create-tmz-step-first' })
					}

					// if (step === 1) {
					//     router.push({name: 'create-tmz-step-second', params: {tmzId: tmzId}});
					// } else if (step === -1){
					//     router.push({name: 'view-tmz-step-first', params: {id: tmzId}});
					// } else if (step === 2) {
					//     router.push({name: 'create-tmz-step-third', params: {tmzId: tmzId}});
					// } else {
					//     router.push({name: 'create-tmz-step-first'});
					// }
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		skipVl1({ dispatch }) {
			return axios
				.post('tmz/import_liquid_demand_tmz_excel_one_one_empty/')
				.then(response => {
					dispatch('addNotification', {
						type: 'success',
						message: 'Шаг пропущен',
					})
					router.push({ name: 'check-tmz-step' })
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		uploadVl1({ commit, dispatch }, formData) {
			return axios
				.post('tmz/import_liquid_demand_tmz_excel_one_one/', formData, {
					// responseType: 'blob',
					onUploadProgress: e =>
						commit('setProgress', Math.round((e.loaded * 100) / e.total)),
				})
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message:
								'Вы успешно загрузили остатки ликвидных запасов за предыдущие финансовые годы',
						})
						setTimeout(() => {
							router.push({ name: 'check-tmz-step' })
						}, 2000)
					} else {
						dispatch('addNotification', {
							type: 'error',
							message:
								'Что-то пошло не так, просьба обратиться в тех. поддержку',
						})
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		reuploadVl1({ commit, dispatch }, formData) {
			return axios
				.post('tmz/import_liquid_demand_tmz_excel_one_error/', formData, {
					// responseType: 'blob',
					onUploadProgress: e =>
						commit('setProgress', Math.round((e.loaded * 100) / e.total)),
				})
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message:
								'Вы успешно загрузили остатки ликвидных запасов за предыдущие финансовые годы',
						})
						router.push({ name: 'check-tmz-step' })
					} else {
						dispatch('addNotification', {
							type: 'error',
							message:
								'Что-то пошло не так, просьба обратиться в тех. поддержку',
						})
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		uploadVl2({ commit, dispatch }, formData) {
			return axios
				.post('tmz/import_liquid_demand_tmz_excel_one_two/', formData, {
					// responseType: 'blob',
					onUploadProgress: e =>
						commit('setProgress', Math.round((e.loaded * 100) / e.total)),
				})
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message:
								'Вы успешно загрузили Востребованный ликвид - текущий месяц',
						})
						setTimeout(() => {
							window.location.reload()
						}, 1000)
					} else {
						// const url = URL.createObjectURL(
						// 	new Blob([response.data], {
						// 		type: 'application/vnd.ms-excel',
						// 	})
						// );
						// const link = document.createElement('a');
						// link.href = url;
						// link.setAttribute('download', 'Исправить ошибки.xlsx');
						// document.body.appendChild(link);
						// link.click();
						dispatch('addNotification', {
							type: 'error',
							message: response.data,
						})
						location.reload()
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		editLiquidDemandTmzExcelOne({ commit, dispatch }, formData) {
			return TmzService.editLiquidDemandTmzExcelOne(formData)
				.then(response => {
					location.reload()
					//router.push({name: 'view-tmz-step-first', params: {id: response.data.tmz_report_id}});
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
				})
		},
		skipNvl1({ dispatch }, formData) {
			return axios
				.post('tmz/import_liquid_unclaimed_tmz_excel_two_one_empty/', formData)
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message: 'Шаг пропущен',
						})
						router.push({ name: 'check-tmz-step' })
					} else {
						const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Исправить ошибки' + name + '.xlsx')
						document.body.appendChild(link)
						link.click()
						location.reload()
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		skipNvl2({ dispatch }, formData) {
			return axios
				.post('tmz/import_liquid_unclaimed_tmz_excel_two_two_empty/', formData)
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message: 'Шаг пропущен',
						})
						location.reload()
					} else {
						const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Исправить ошибки' + name + '.xlsx')
						document.body.appendChild(link)
						link.click()
						location.reload()
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		uploadNvl1({ commit, dispatch }, formData) {
			return axios
				.post('tmz/import_liquid_unclaimed_tmz_excel_two_one/', formData, {
					onUploadProgress: e =>
						commit('setProgress', Math.round((e.loaded * 100) / e.total)),
				})
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message:
								'Вы успешно загрузили Не Востребованный ликвид - остатки за предыдущие финансовые годы',
						})
						location.reload()
					} else {
						const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Исправить ошибки' + name + '.xlsx')
						document.body.appendChild(link)
						link.click()
						location.reload()
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		uploadNvl2({ commit, dispatch }, formData) {
			return axios
				.post('tmz/import_liquid_unclaimed_tmz_excel_two_two/', formData, {
					onUploadProgress: e =>
						commit('setProgress', Math.round((e.loaded * 100) / e.total)),
				})
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message:
								'Вы успешно загрузили Не Востребованный ликвид - текущий месяц',
						})
						location.reload()
					} else {
						const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Исправить ошибки.xlsx')
						document.body.appendChild(link)
						link.click()
						location.reload()
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		editLiquidUnclaimedTmzExcelTwo({ commit, dispatch }, formData) {
			return TmzService.editLiquidUnclaimedTmzExcelTwo(formData)
				.then(response => {
					location.reload()
					//router.push({name: 'view-tmz-step-second', params: {id: response.data.tmz_report_id}});
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
				})
		},
		skipLiq1({ dispatch }, formData) {
			return axios
				.post('tmz/import_illiquid_tmz_excel_three_one_empty/', formData)
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message: 'Шаг пропущен',
						})
						router.push({ name: 'check-tmz-step' })
					} else {
						const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Исправить ошибки' + name + '.xlsx')
						document.body.appendChild(link)
						link.click()
						location.reload()
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		skipLiq2({ dispatch }, formData) {
			return axios
				.post('tmz/import_illiquid_tmz_excel_three_two_empty/', formData)
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message: 'Шаг пропущен',
						})
						location.reload()
					} else {
						const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Исправить ошибки' + name + '.xlsx')
						document.body.appendChild(link)
						link.click()
						location.reload()
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		uploadLiq1({ commit, dispatch }, formData) {
			return axios
				.post('tmz/import_illiquid_tmz_excel_three_one/', formData, {
					onUploadProgress: e =>
						commit('setProgress', Math.round((e.loaded * 100) / e.total)),
				})
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message:
								'Вы успешно загрузили Не ликвид - остатки за предыдущие финансовые годы',
						})
						// router.push({name: 'check-tmz-step'});
						location.reload()
					} else {
						const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Исправить ошибки' + name + '.xlsx')
						document.body.appendChild(link)
						link.click()
						location.reload()
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		uploadLiq2({ commit, dispatch }, formData) {
			return axios
				.post('tmz/import_illiquid_tmz_excel_three_two/', formData, {
					onUploadProgress: e =>
						commit('setProgress', Math.round((e.loaded * 100) / e.total)),
				})
				.then(response => {
					if (response.status === 201) {
						dispatch('addNotification', {
							type: 'success',
							message: 'Вы успешно загрузили Не ликвид - текущий месяц',
						})
						location.reload()
					} else {
						const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Исправить ошибки.xlsx')
						document.body.appendChild(link)
						link.click()
						location.reload()
					}
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					setTimeout(function() {
						location.reload()
					}, 2000)
				})
		},
		editIlliquidTmzExcelThree({ commit, dispatch }, formData) {
			return TmzService.editIlliquidTmzExcelThree(formData)
				.then(response => {
					location.reload()
					//router.push({name: 'view-tmz-step-third', params: {id: response.data.tmz_report_id}});
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error.response.data)
					//location.reload();
				})
		},
		getTmzReport({ commit, dispatch }, id) {
			return axios
				.get(`tmz/tmz-view/${id}/`)
				.then(response => {
					commit('setTmzReport', response.data)
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getTmzError({ commit, dispatch }, id) {
			return axios
				.get(`tmz/tmz-error/${id}/`)
				.then(response => {
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getTmzErrorCount({ commit, dispatch }, id) {
			return axios
				.get(`tmz/tmz-error/${id}/count/`)
				.then(response => {
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getLiquidDemandReport({ commit, dispatch }, formData) {
			let id = formData.liquidDemand
			return axios
				.get(`tmz/liquid-demand/${id}/`)
				.then(response => {
					commit('setLiquidDemandReport', response.data)
					return response.data
				})
				.catch(error => {
					// dispatch('addNotification', {
					// 	type: 'error',
					// 	message: error.response.data,
					// });
					console.log(error)
				})
		},
		getLiquidDemandReportRequest({ commit, dispatch }, formData) {
			console.log(formData)
			return axios
				.get(`tmz/liquid-demand-req/`, {
					params: {
						liquidDemandId: formData.liquidDemand,
						category: formData.category || '',
						codeTmc: formData.codeTmc || '',
						nameTmc: formData.nameTmc || '',
					},
				})
				.then(response => {
					commit('setLiquidDemandReportRequest', response.data)
					console.log(response)
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getLiquidDemandRequestDataDate({ commit, dispatch }, id) {
			return TmzService.getLiquidDemandRequestDataDate(id)
				.then(response => {
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getLiquidDemandRequestDataPrice({ commit, dispatch }, id) {
			return TmzService.getLiquidDemandRequestDataPrice(id)
				.then(response => {
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getLiquidUnclaimedReport({ commit, dispatch }, formData) {
			let id = formData.liquidUnclaimed
			return axios
				.get(`tmz/liquid-unclaimed/${id}/`)
				.then(response => {
					commit('setLiquidUnclaimedReport', response.data)
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getLiquidUnclaimedReportRequest({ commit, dispatch }, formData) {
			console.log(formData)
			return axios
				.get(`tmz/liquid-unclaimed-req/`, {
					params: {
						liquidUnclaimedId: formData.liquidUnclaimed,
						category: formData.category || '',
						codeTmc: formData.codeTmc || '',
						nameTmc: formData.nameTmc || '',
					},
				})
				.then(response => {
					commit('setLiquidUnclaimedReportRequest', response.data)
					console.log(response)
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getLiquidUnclaimedRequestDataDate({ commit, dispatch }, id) {
			return TmzService.getLiquidUnclaimedRequestDataDate(id)
				.then(response => {
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getIlliquidReportRequest({ commit, dispatch }, formData) {
			console.log(formData)
			return axios
				.get(`tmz/illiquid-req/`, {
					params: {
						illiquidId: formData.illiquid,
						codeTmc: formData.codeTmc || '',
						nameTmc: formData.nameTmc || '',
					},
				})
				.then(response => {
					commit('setIlliquidReportRequest', response.data)
					console.log(response)
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getIlliquidRequestDataDate({ commit, dispatch }, id) {
			return TmzService.getIlliquidRequestDataDate(id)
				.then(response => {
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		getIlliquidReport({ commit, dispatch }, formData) {
			let id = formData.illiquid
			return axios
				.get(`tmz/illiquid/${id}/`)
				.then(response => {
					commit('setIlliquidReport', response.data)
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		sendSignXmlTmz({ commit }, formData) {
			return TmzService.sendSignXmlTmz(formData)
		},
		getAllTmzReports({ commit, dispatch }, page) {
			let payload = {
				page: page,
			}
			return axios
				.get(`tmz/all-tmz/`, {
					params: payload
				})
				.then(response => {
					commit('setTmzReports', response.data.results)
					commit('setTmzReportsCount', response.data.count)
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					if (error.response.data.detail === 'Signature has expired.') {
						dispatch('logout')
					}
				})
		},
		getTmzOtherReports({ commit, dispatch }) {
			return axios
				.get(`tmz/all-not-my-tmz/`)
				.then(response => {
					commit('setTmzOtherReports', response.data.results)
					commit('setTmzOtherReportsCount', response.data.count)
					return response.data
				})
				.catch(error => {
					console.log(error.response.data)
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					if (error.response.data.detail === 'Signature has expired.') {
						dispatch('logout')
					}
				})
		},
		rmTmzReport({ commit, dispatch }, id) {
			return TmzService.rmTmzReport(id)
				.then(response => {
					router.push({ name: 'tmz-my-report' })
					dispatch('addNotification', {
						type: 'success',
						message: 'Удаление прошло успешно',
					})
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error.response.data)
				})
		},
		decideProblem({ commit, dispatch }) {
			return TmzService.decideProblem()
				.then(response => {
					console.log(response.data)
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error.response.data)
				})
		},
		getTmzHistory({ commit, dispatch }, id) {
			return TmzService.getTmzHistory(id)
				.then(response => {
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error.response.data)
				})
		},
		rejectTmzReportDzo({ commit, dispatch }, formData) {
			return TmzService.rejectTmzReportDzo(formData)
				.then(response => {
					router.push({ name: 'tmz-my-report' })
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		sendTmzEditFile({ commit, dispatch }, formData) {
			return TmzService.sendTmzEditFile(formData)
				.then(response => {
					router.push({ name: 'tmz-my-report' })
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		rejectTmzReport({ commit, dispatch }, formData) {
			return TmzService.rejectTmzReportAllow(formData)
				.then(response => {
					commit('test')
					router.push({ name: 'reports' })
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		rejectTmzAdjustment({ dispatch }, formData) {
			console.log(`tmz/reject-reject-tmz/${formData.reportId}/`)
			return axios
				.get(`tmz/reject-reject-tmz/${formData.reportId}/`)
				.then(response => {
					// console.log(response)
					router.push({ name: 'reports' })
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
					console.log(error)
				})
		},
		downLoadTmzExcel({ commit }, formData) {
			return TmzService.downLoadTmzExcel(formData)
				.then(response => {
					const url = URL.createObjectURL(
						new Blob([response.data], {
							type: 'application/vnd.ms-excel',
						})
					)
					const link = document.createElement('a')
					link.href = url
					let name = ''
					console.log(formData)
					if (formData.reportId) {
						name = formData.reportId
					}
					if (formData.month) {
						name = formData.month
					}
					link.setAttribute('download', 'Отчет_тмз_' + name + '.xlsx')
					document.body.appendChild(link)
					link.click()
					commit('test')
				})
				.catch(error => {
					console.log(error)
				})
		},
		downErrorExcel({ commit }, tmzId) {
			return TmzService.downErrorExcel(tmzId)
				.then(response => {
					const url = URL.createObjectURL(
						new Blob([response.data], {
							type: 'application/vnd.ms-excel',
						})
					)
					const link = document.createElement('a')
					link.href = url
					let name = ''
					console.log(tmzId)
					if (tmzId) {
						name = tmzId
					}
					if (tmzId) {
						name = tmzId
					}
					link.setAttribute('download', 'Исправить_ошибки_' + name + '.xlsx')
					document.body.appendChild(link)
					link.click()
					commit('test')
				})
				.catch(error => {
					console.log(error)
				})
		},
		getTmzFormSix({ commit, dispatch }, reportId) {
			return TmzService.getTmzFormSix(reportId)
				.then(response => {
					return response.data
				})
				.catch(error => {
					dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					})
				})
		},
	},
}
